var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-cv-popup', {
    attrs: {
      "data-to-show": _vm.stepNewCvPopupDisplayed,
      "errors": _vm.errorsCreateNewCv
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupNewCV(-1);
      },
      "createNewCv": function (infos) {
        _vm.newCV(infos);
      },
      "changePage": function (step) {
        return _vm.stepNewCvPopupDisplayed = step;
      }
    }
  }), _vm._v(" "), _c('remove-cv-popup', {
    attrs: {
      "data-to-show": _vm.isRemoveCvPopupDisplayed,
      "cv-to-delete": _vm.cvToDelete
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupRemoveCV(false);
      },
      "removeCV": function (cv) {
        _vm.remove(cv);
      }
    }
  }), _vm._v(" "), _c('add-button', {
    staticClass: "px-5 lg:px-14 mb-10",
    attrs: {
      "libelle": "Créer un nouveau CV"
    },
    on: {
      "add": function ($event) {
        return _vm.displayPopupNewCV(1);
      }
    }
  }), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l(_vm.listCvs, function (cv, i) {
    return _c('div', {
      key: 'cv' + i,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50 hover:bg-indigo-200 odd:hover:bg-indigo-200 h-16 lg:h-24 2xl:h-32 pl-5 lg:pl-14 grid grid-cols-12 lg:gap-x-4 place-content-center items-center cursor-default"
    }, [_c('div', {
      staticClass: "col-span-3 lg:col-span-4 text-base text-gray-900"
    }, [_vm._v("\n                " + _vm._s(cv.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "hidden lg:col-span-4 text-sm line-clamp-2 pr-5 justify-self-start place-self-center italic font-light"
    }, [_c('p', {
      staticClass: "break-all"
    }, [_vm._v(_vm._s(cv.description))])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 lg:col-span-1 text-base"
    }, [_vm._v("\n                " + _vm._s(new Date(cv.created_at).toLocaleDateString('fr')) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 lg:col-span-2 text-base flex justify-center"
    }, [_vm._v("\n                " + _vm._s(cv.type === "basic" ? "Classique" : "Dashboard") + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 relative"
    }, [_c('div', {
      staticClass: "more-menu p-2 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayMore(i);
        }
      }
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    })], 1), _vm._v(" "), _vm.indexMenuToDisplay === i ? _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.forceHide,
        expression: "forceHide"
      }],
      staticClass: "absolute right-5 z-10"
    }, [_c('div', {
      staticClass: "flex flex-col space-y-2 bg-white rounded-xl p-4 shadow-lg text-sm text-gray-600"
    }, [_c('router-link', {
      staticClass: "hover:text-gray-900",
      attrs: {
        "to": {
          name: 'CvForm',
          params: {
            user: _vm.user.id,
            id: cv.id
          }
        }
      }
    }, [_vm._v("\n                            Modifier\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "cursor-pointer hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.dupplicate(i);
        }
      }
    }, [_vm._v("\n                            Dupliquer\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "cursor-pointer hover:text-gray-900",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayPopupRemoveCV(true, cv);
        }
      }
    }, [_vm._v("\n                            Supprimer\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "cursor-pointer hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.download(i);
        }
      }
    }, [_vm._v("\n                            Télécharger\n                        ")])], 1)]) : _vm._e()])]);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }